import React, { ReactElement } from 'react';
import { NeueTooltip } from 'src/editor/content-creation/components/tooltip';
import { Placement } from '@floating-ui/react-dom';
import { useJourneys } from 'src/store/journeys';
import { FreeGatingEnum, FreeGatingModalTooltipContentMapping } from './store';
import { useCurrentOrganization } from 'src/store/organization';
import { useFeatureRestrictions } from 'src/hooks/useFeatureRestrictions';

export const FreeGatingTooltip = ({
  children,
  content = FreeGatingModalTooltipContentMapping[FreeGatingEnum.JOURNEYS],
  showTooltip,
  placement = 'right',
}: {
  children: ReactElement;
  content?: string;
  showTooltip?: boolean;
  placement?: Placement;
}) => {
  const { checkFeature } = useFeatureRestrictions();

  // Only show tooltip if user cannot create journeys (Start plan users who reached their limit)
  const shouldShowTooltip = !checkFeature('journey_creation');

  if (typeof showTooltip !== 'undefined' ? !showTooltip : !shouldShowTooltip) {
    return children;
  }

  return (
    <NeueTooltip tooltipContent={content} tooltipContentClassName='bg-bedrock-black text-white' placement={placement}>
      {children}
    </NeueTooltip>
  );
};
